import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { action, extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import moment from 'moment'

class LocalTime extends Component {
  static propTypes = {
    staticData: PropTypes.object,
    timezoneId: PropTypes.number
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      time: 'N/A'
    })
  }

  componentDidMount () {
    if (this.props.timezoneId) {
      this.generateTime()

      /* NOTE: clock can be as late as this interval is set (current 1 second) */
      this.interval = setInterval(this.generateTime, 1000)
    }
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  generateTime = action(() => {
    const { timezoneId, staticData } = this.props
    const timezone = staticData.timezones.find(item => item.id === timezoneId)
    const time = moment()
      .tz(timezone.name)
      .format('HH:mm')

    this.time = time
  })

  render () {
    return (
      <div className='floating'>
        <h1>{this.time}</h1>
        <span>Local time</span>
      </div>
    )
  }
}

export default inject('staticData')(observer(LocalTime))
